import { render } from "./Career.vue?vue&type=template&id=63544356&scoped=true"
import script from "./Career.vue?vue&type=script&lang=js"
export * from "./Career.vue?vue&type=script&lang=js"

import "./Career.vue?vue&type=style&index=0&id=63544356&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63544356"]])

export default __exports__